import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import styles from './MissingAccess.module.scss';

/* eslint-disable-next-line */
export interface MissingAccessProps {}

export const MissingAccess: React.FC<MissingAccessProps> = () => {
  const { t } = useTranslation();
  return (
    <div className={styles['container']}>
      <div className={styles['info-container']}>
        <Text headingSize="m" className={styles['heading']}>
          {`${t('user-missing-access-to-app-title')}`}
        </Text>
        <Text>{`${t('user-missing-access-to-app-content')}`}</Text>
      </div>
    </div>
  );
};
